export enum orderTypes {
    PRICE_ASC = 'precioAsc',
    PRICE_DESC = 'precioDes',
    RECOMMENDED = 'recommended',
    NEWEST = 'newest',
    BEST_SELLER = 'bestSeller',
    BEST_MATCH = 'bestMatch',
}

export interface ProductFilterOrderItem {
    name: string;
    description: number | string;
    value: orderTypes;
    checked: boolean;
}

export interface ProductFilterFormItem {
    name: string;
    description: number | string;
    isChecked: boolean;
}

export interface ProductFilterItem {
    name?: string;
    price?: number;
    value?: string;
    filterGroup?: string;
    productIds?: number[];
    isChecked: boolean;
}

export type filterGroupArrayNames =
    | 'attributeFilter'
    | 'backsoonFilter'
    | 'catFilter'
    | 'catRelFilter'
    | 'colFilter'
    | 'discountFilter'
    | 'joinLifeFilter'
    | 'lastSizesFilter'
    | 'maxPriceFilter'
    | 'minPriceFilter'
    | 'sizeFilter'
    | 'sizeGroupFilter'
    | 'typeFilter'
    | 'XCALFILTER'
    | 'XCATEGORY'
    | 'XCATEGORY2'
    | 'XCATEGORY3'
    | 'XCATEGORY4';

export type ProductFilterItemArray = Record<string, ProductFilterItem[]>;

export type ProductFilterIdsProductArray = Record<string, number[]>;

export interface FilterEmitter {
    filtersGroup: filterGroupArrayNames;
    filtersGroupArray: ProductFilterItemArray;
}

// TODO ECOMDUTI-13739 TESTAB TEST A/B - Desarrollo Personalización Contenido - Maqueta de filtros
export interface DisplayFilterValues {
    value: number;
}

export interface DisplayFilterSliderValues extends DisplayFilterValues {
    descrip: string;
    percentage?: number;
}

export interface DisplayFilterIconsValues extends DisplayFilterValues {
    icons: Icons;
}
export interface DisplayFilterNumericValues extends DisplayFilterValues {
    descrip: string;
    mobileDescrip: string;
}

export interface Icons {
    empty: string;
    filled: string;
}
